/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import axios from 'axios';
import { t } from 'ttag';
import * as generalTrans from '../translations/general_trans';
import GenericPopup from '../../../../../reusable-components/GenericPopup/GenericPopup';
// eslint-disable-next-line import/no-named-as-default
import isEmail from '../../../../../utils/isEmail';

// Check if there is whitespace or empty
function isNotEmpty(value) {
  if (value.replace(/\s/g, '').length) {
    return true;
  }
  return false;
}

export default class EmailStep extends PureComponent {
  constructor(props) {
    super(props);
    this.termsRef = React.createRef();
    this.state = {
      showPopup1: false,
      showPopup2: false,
      firstnameActive: false,
      firstnameWarning: '',
      firstname: '',
      // phoneActive: false,
      // phoneWarning: '',
      // phone: '',
      email: '',
      emailActive: false,
      emailWarning: '',
      showGeneralErr: false,
      onChecked: null,
      // sizeActive: false,
      // sizeWarning: '',
      // shoeSize: 'invalid',
      gTrans: window.location.href.includes('.at')
        ? generalTrans.at
        : generalTrans[window.campaign_data.common_translations.language],
      common: window.campaign_data.common_translations.blocks,
      translations: window.campaign_data.campaign_translations.blocks,
      // isMobile: window.innerWidth < 767,
      popupsLoaded: false,
      text: '',
      content: props.content,
      campaignType: props.campaignType,
    };
  }

  componentDidMount() {
    // Handling austrian translations
    if (window.campaign_data.common_translations.language === 'de-AT') {
      this.setState({
        gTrans: generalTrans.at,
      });
    }

    axios.get('/policies/short_permission/').then((response) => {
      // console.log('response', response);
      this.setState({
        text: response.data.permission_text,
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.popupsLoaded === false) {
      this.setState({
        popupsLoaded: true,
      });
      if (
        this.termsRef.current.childNodes[2] &&
        this.termsRef.current.childNodes[2].style
      ) {
        this.termsRef.current.childNodes[2].style.color = this.props.textColor;
      }
      if (window.config.language_code === 'nl') {
        if (
          this.termsRef.current.childNodes[5] &&
          this.termsRef.current.childNodes[5].style
        ) {
          this.termsRef.current.childNodes[5].style.color =
            this.props.textColor;
        }
      } else if (
        this.termsRef.current.childNodes[4] &&
        this.termsRef.current.childNodes[4].style
      ) {
        this.termsRef.current.childNodes[4].style.color = this.props.textColor;
      }
    }
  }

  // Start set active
  setActive(active) {
    // if (active === 'phone') {
    //   this.setState({
    //     phoneActive: true,
    //   });
    //   if (!isNotEmpty(this.state.email)) {
    //     this.setState({
    //       emailActive: false,
    //     });
    //   }
    // }
    if (active === 'email') {
      this.setState({
        emailActive: true,
      });
      // if (!isNotEmpty(this.state.phone)) {
      //   this.setState({
      //     phoneActive: false,
      //   });
      // }
    }

    if (active === 'firstname') {
      this.setState({
        firstnameActive: true,
      });
      if (!isNotEmpty(this.state.email)) {
        this.setState({
          emailActive: false,
        });
      }
    }
    if (active === 'email') {
      this.setState({
        emailActive: true,
      });
      // if (!isNotEmpty(this.state.firstname)) {
      // this.setState({
      // firstnameActive: false,
      // });
      // }
    }
    if (active === 'email') {
      this.setState({
        emailActive: true,
      });
      if (this.state.onChecked === true) {
        this.setState({
          emailActive: true,
        });
      }
    }
  }

  // Start phone
  // handlePhoneActive() {
  //   this.setActive('phone');
  // }
  // handlePhoneInput(event) {
  //   this.setState({ phone: event.target.value });
  //   this.validatePhone(event.target.value);
  // }
  // validatePhone(phone) {
  //   if (isNotEmpty(phone)) {
  //     this.setState({ phoneWarning: false });
  //     return true;
  //   } else if (!isNotEmpty(phone)) {
  //     this.setState({ phoneWarning: this.state.gTrans.error7 });
  //   }
  //   return false;
  // }

  // Start size
  // handleSizeActive() {
  //   this.setActive('shoeSize');
  // }
  // handleSizeInput(event) {
  //   if (this.validateSize(event.target.value)) {
  //     this.setState({ shoeSize: event.target.value });
  //   }
  // }

  // validateSize(size) {
  //   if (size !== 'invalid') {
  //     this.setState({ sizeWarning: '' });
  //     return true;
  //   } else if (size === 'invalid') {
  //     this.setState({
  //       sizeWarning: this.state.gTrans.error7,
  //       shoeSize: 'invalid',
  //     });
  //   }
  //   return false;
  // }

  setPopup(popupNr) {
    this.setState((prevState) => {
      return {
        [`showPopup${popupNr}`]: !prevState[`showPopup${popupNr}`],
      };
    });
  }

  // Start email
  handleEmailActive() {
    this.setActive('email');
  }

  getText() {
    return { __html: this.state.text };
  }

  handleEmailInput(event) {
    this.setState({ email: event.target.value });
    this.validateEmail(event.target.value);
  }

  validateEmail(email) {
    if (isNotEmpty(email) && isEmail(email)) {
      this.setState({ emailWarning: false });
      return true;
    }
    if (!isNotEmpty(email)) {
      this.setState((prevState) => {
        return { emailWarning: prevState.gTrans.error7 };
      });
    } else if (!isEmail(email)) {
      this.setState((prevState) => {
        return { emailWarning: prevState.gTrans.error3 };
      });
    }
    return false;
  }

  handleData(event) {
    try {
      event.preventDefault();
      let canContinue = true;
      // canContinue = this.validateSize(this.state.shoeSize) && canContinue;
      // canContinue = this.validatePhone(this.state.phone) && canContinue;
      // canContinue = this.validateFirstname(this.state.firstname) && canContinue;
      canContinue = this.validateEmail(this.state.email) && canContinue;
      canContinue =
        this.state.emailWarning === false &&
        this.state.onChecked === true &&
        canContinue;
      if (canContinue) {
        const data = {
          email: this.state.email,
          // phone: this.state.phone,
          // shoe_size: this.state.shoeSize,
          name: this.state.firstname,
        };
        this.props.onNextClick(data);
      } else if (this.state.onChecked === null) {
        this.setState({
          onChecked: false,
        });
      } else {
        this.setState({
          emailActive: true,
        });
      }
    } catch (error) {
      this.setState({
        showGeneralErr: true,
      });
    }
  }

  // Start first name
  handleFirstnameActive() {
    this.setActive('firstname');
  }

  handleFirstnameInput(event) {
    this.setState({ firstname: event.target.value });
    this.validateFirstname(event.target.value);
  }

  validateFirstname(firstname) {
    if (isNotEmpty(firstname)) {
      this.setState({ firstnameWarning: false });
      return true;
    }
    if (!isNotEmpty(firstname)) {
      this.setState((prevState) => {
        return { firstnameWarning: prevState.gTrans.error7 };
      });
    }
    return false;
  }

  render() {
    const { gTrans } = this.state;
    return (
      <section className="email-section">
        <div className="signupWrapper">
          <h2
            className="storyTitle title"
            style={{ color: this.props.titleColor }}
          >
            {' '}
            {this.state.campaignType === 'general'
              ? this.state.translations[`${this.state.content}title`]
              : this.state.translations.signuptitle}{' '}
          </h2>
          <p
            className="interestCategoryText"
            style={{ color: this.props.textColor }}
            dangerouslySetInnerHTML={{
              __html:
                this.state.campaignType === 'general'
                  ? this.state.translations[`${this.state.content}text`]
                  : this.state.translations.signuptext,
            }}
          />
          {this.state.showGeneralErr === true && (
            <p className="generalErr">{this.state.gTrans.error5}</p>
          )}
          <div
            id="firstname"
            className={
              this.state.firstnameActive ? 'active relative' : 'relative'
            }
          >
            <label htmlFor="name">{this.state.common.placeholdername}</label>
            <input
              className={this.state.firstnameWarning ? 'redBottom' : 'noBottom'}
              type="text"
              name="name"
              value={this.state.firstname}
              autoComplete="off"
              required=""
              onFocus={(event) => this.handleFirstnameActive(event)}
              onChange={(event) => this.handleFirstnameInput(event)}
              style={{ borderBottomColor: this.props.ctaBorderColor }}
            />
            <p className="firstnameWarning">{this.state.firstnameWarning}</p>
          </div>
          <div
            id="email"
            className={this.state.emailActive ? 'active relative' : 'relative'}
          >
            <label htmlFor="email">{this.state.common.placeholderemail}</label>
            <input
              className={this.state.emailWarning ? 'redBottom' : 'noBottom'}
              type="text"
              name="email"
              value={this.state.email}
              autoComplete="off"
              required=""
              onFocus={(event) => this.handleEmailActive(event)}
              onChange={(event) => this.handleEmailInput(event)}
              style={{ borderBottomColor: this.props.ctaBorderColor }}
            />
          </div>
          <p className="emailWarning">{this.state.emailWarning}</p>

          {/* <div
            id="phone"
            className={this.state.phoneActive ? "active relative" : "relative"}>
            <label htmlFor="email">
              {this.state.common.phonenumber}
            </label>
            <input
              className={this.state.phoneWarning ? "redBottom" : "noBottom"}
              type="text"
              name="email"
              value={this.state.phone}
              autoComplete="off"
              required=""
              onFocus={(event) => this.handlePhoneActive(event)}
              onChange={(event) => this.handlePhoneInput(event)}
            />
          <p className="phoneWarning">{this.state.phoneWarning}</p>
          </div>
          <div
            id="size"
            className=
            {this.state.sizeActive ? "active form-group relative" : "form-group relative"}>
            <select
              required
              className=
              {this.state.sizeWarning ? "form-control redBorder" : "form-control noBottom"}
              id="id_size"
              name="shoeSize"
              defaultValue=""
              onFocus={(event) => this.handleSizeActive(event)}
              onChange={(event) => this.handleSizeInput(event)}
            >
                <option value="invalid">{this.state.common.choosesize}</option>
                <option value="40">  EU 40 / US 7 </option>
                <option value="40½">  EU 40½ / US 7½ </option>
                <option value="41">  EU 41 / US 8 </option>
                <option value="42">  EU 42 / US 8½ </option>
                <option value="42½">  EU 42½ / US 9 </option>
                <option value="43">  EU 43 / US 9½ </option>
                <option value="44">  EU 44 / US 10 </option>
                <option value="44½">  EU 44½ / US 10½ </option>
                <option value="45">  EU 45 / US 11 </option>
                <option value="45½">  EU 45½ / US 11½ </option>
                <option value="46">  EU 46 / US 12 </option>
            </select>
            <p className="sizeWarning">{this.state.sizeWarning}</p>
          </div> */}

          <div
            id="terms"
            className={this.state.emailActive ? 'active relative' : 'relative'}
          >
            <div htmlFor="container" className="container">
              <input
                className="checkbox"
                type="checkbox"
                required=""
                onChange={(event) =>
                  this.setState({ onChecked: event.target.checked })
                }
              />
              <span
                className={
                  this.state.onChecked === false ? 'checkmarkRed' : 'checkmark'
                }
              >
                {' '}
              </span>
              <p
                ref={this.termsRef}
                className="termsAndConditions"
                dangerouslySetInnerHTML={this.getText()}
                style={{ color: this.props.textColor }}
              />
              {this.state.showPopup1 && (
                <GenericPopup
                  title={t`Read our terms`}
                  closeModal={() => this.setPopup(1)}
                  type="policy"
                  name="long_permission"
                  target=".site-modal"
                />
              )}
              {this.state.showPopup2 && (
                <GenericPopup
                  title={t`Privacy policy`}
                  closeModal={() => this.setPopup(2)}
                  type="policy"
                  name="privacy"
                  target=".site-modal"
                />
              )}
              <div className="terms_link_wrapper termsAndConditions">
                <span
                  className="popup-link"
                  style={{ color: this.props.textColor }}
                  role="button"
                  tabIndex={0}
                  onClick={() => this.setPopup(1)}
                >{t`Read our terms`}</span>
                {' | '}
                <span
                  className="popup-link"
                  style={{ color: this.props.textColor }}
                  role="button"
                  tabIndex={0}
                  onClick={() => this.setPopup(2)}
                >{t`Privacy policy`}</span>
              </div>
            </div>
          </div>
          <div>
            {this.state.onChecked === false && (
              <p
                className={
                  this.state.gTrans.confirmConsentText ? 'termsWarning' : 'hide'
                }
              >
                {this.state.gTrans.confirmConsentText}
              </p>
            )}
          </div>
          <button
            className={`signup ${this.props.roundTheCorners}`}
            onClick={(event) => this.handleData(event)}
            style={{
              backgroundColor: this.props.ctaBackgroundColor,
              color: this.props.ctaTextColor,
              borderBottomColor: this.props.ctaBorderColor,
            }}
            type="button"
          >
            {gTrans.ctaSignup}
          </button>
        </div>
      </section>
    );
  }
}
